import { render, staticRenderFns } from "./limit-info.vue?vue&type=template&id=0ecbda35&"
import script from "./limit-info.vue?vue&type=script&lang=js&"
export * from "./limit-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ecbda35')) {
      api.createRecord('0ecbda35', component.options)
    } else {
      api.reload('0ecbda35', component.options)
    }
    module.hot.accept("./limit-info.vue?vue&type=template&id=0ecbda35&", function () {
      api.rerender('0ecbda35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/externalPurchases/partials/limit-info.vue"
export default component.exports